import { setUnreadMessagesCountAction } from "./actionTypes"

export const setUnreadMessageCount = (count: number) => ({type: setUnreadMessagesCountAction, payload: count})